module.exports = __webpack_public_path__ + "img/59-r.d0a537db.png";